import sharedMutations from "@/store/utils/shared-mutations";
import { Athlete } from "@/models";

const SET_FAVOURITE = (state, athleteId) => {
  const athlete = state.athletes.find(athlete => athlete["Id"] === athleteId);
  state.athletes.splice(
    state.athletes.indexOf(athlete),
    1,
    new Athlete({ ...athlete, favC: true })
  );
};

const UNSET_FAVOURITE = (state, athleteId) => {
  const athlete = state.athletes.find(college => college["Id"] === athleteId);
  state.athletes.splice(
    state.athletes.indexOf(athlete),
    1,
    new Athlete({ ...athlete, favC: false })
  );
};

const SET_FAVOURITE_FOR_INSTITUTION = (state, institutionId) => {
  const institution = state.profileViews.find(
    view =>
      view['viewBy'] && view['viewBy']["CollegeId"]&& view['viewBy']["CollegeId"]["id"] ||  view['viewBy'] && view['viewBy']["clubId"] && view['viewBy']["clubId"]["id "] === institutionId 
  );
  state.profileViews.splice(
    state.profileViews.indexOf(institution),
    1,
    new Athlete({ ...institution, favC: true })
  );
};

const UNSET_FAVOURITE_FOR_INSTITUTION = (state, institutionId) => {
  const institution = state.profileViews.find(
    view =>
      view['viewByInstitution'] && view['viewByInstitution']["id"] === institutionId 
  );
  state.profileViews.splice(
    state.profileViews.indexOf(institution),
    1,
    new Athlete({ ...institution, favC: false })
  );
};

const SET_ATHLETE_FAVOURITE = state => {
  state.athlete = new Athlete({ ...state.athlete, favC: true });
};

const UNSET_ATHLETE_FAVOURITE = state => {
  state.athlete = new Athlete({ ...state.athlete, favC: false });
};

export default {
  ...sharedMutations,
  SET_FAVOURITE,
  UNSET_FAVOURITE,
  SET_FAVOURITE_FOR_INSTITUTION,
  UNSET_FAVOURITE_FOR_INSTITUTION,
  SET_ATHLETE_FAVOURITE,
  UNSET_ATHLETE_FAVOURITE
};
